import React, { useState, useEffect } from 'react';
import { MultiSelect } from 'react-multi-select-component';
import { PrinterItemInputWrapper, InputHeadingWrapper, InputFieldWrapper, DropdownInputWrapper } from './PrintDropdown.styles';
import Select from 'react-select';
import { SelectOption } from '../../types/ViewModel/SelectOption';
import CommonTooltip from '../ui/tooltip/CommonTooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
    heading: string;
    multiple: boolean;
    options: SelectOption[];
    onChange: (selection: any) => void;
    clearSelected?: boolean;
    defaultSelection?: SelectOption;
    tooltipId?: string;
};

const PrintDropdownComponent: React.FC<Props> = (props) => {
    const [selectedItems, setSelectedItems] = useState<SelectOption[]>(props.defaultSelection ? [props.defaultSelection] : []);

    useEffect(() => {
        setSelectedItems(props.defaultSelection ? [props.defaultSelection] : []);
    }, []);

    useEffect(() => {
        if (props.clearSelected) setSelectedItems([]);
    }, [props.clearSelected]);

    const inputHandler = (selection: any) => {
        let selItems: SelectOption[] = [];
        if (props.multiple) {
            selItems = selection;
        } else {
            selItems.push(selection);
        }
        setSelectedItems(selItems);
        props.onChange(selection);
    };

    const styles = {
        control: (css) => ({ ...css, display: 'inline-flex', width: '100%', borderRadius: '0 4px 4px 0' }),
    };

    return (
        <PrinterItemInputWrapper>
            <InputHeadingWrapper>
                {props.heading}
                {props.tooltipId && (
                    <div style={{ paddingLeft: '5px' }}>
                        <CommonTooltip tooltipId={props.tooltipId} width={400}>
                            <FontAwesomeIcon icon="info-circle" />
                        </CommonTooltip>
                    </div>
                )}
            </InputHeadingWrapper>
            <InputFieldWrapper>
                <DropdownInputWrapper isNotValid={false}>
                    {props.multiple && (
                        <MultiSelect
                            value={selectedItems}
                            options={props.options}
                            onChange={inputHandler}
                            className="select-input"
                            labelledBy="Select"
                            disableSearch={true}
                        />
                    )}
                    {!props.multiple && (
                        <Select
                            value={selectedItems}
                            options={props.options}
                            onChange={inputHandler}
                            styles={styles}
                            isSearchable={false}
                            isMulti={false}
                            className="select-input"
                        />
                    )}
                </DropdownInputWrapper>
            </InputFieldWrapper>
        </PrinterItemInputWrapper>
    );
};

export default PrintDropdownComponent;
